import React from "react";
import "../styles/Consumerbanner.css";

import img1 from "../consume-banner/assets/pachan/consume2.png";
import img2 from "../consume-banner/assets/pachan/consume1.png";
import img3 from "../consume-banner/assets/pachan/consume3.png";

const PachancareConsumeBanner = () => {
  const steps = [
    {
      img: img1,
      title: "Step 1",
      text: "Take 1 scoop (2.5–3g) of the powder",
    },
    {
      img: img2,
      title: "Step 2",
      text: "Mix it into 1 cup of lukewarm water & stir well",
    },
    {
      img: img3,
      title: "Step 3",
      text: "Drink twice a day, at least 30 minutes before meals",
    },
  ];

  return (
    <section className="consume-banner">
      <h2 className="consume-heading">
        सेवन करने का तरीका (How To Consume)
      </h2>

      <div className="consume-images">
        {steps.map((step, index) => (
          <div className="consume-card" key={index}>
            <img src={step.img} alt={step.title} />
            <h4>{step.title}</h4>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PachancareConsumeBanner;
